import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const DataFeeds = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="data-feeds-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9998 12.9379C12.414 12.9379 12.7498 13.2737 12.7498 13.6879V20.4379C12.7498 20.8521 12.414 21.1879 11.9998 21.1879C11.5856 21.1879 11.2498 20.8521 11.2498 20.4379V13.6879C11.2498 13.2737 11.5856 12.9379 11.9998 12.9379Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65694 17.0951C8.94984 16.8022 9.42471 16.8022 9.7176 17.0951L11.9998 19.3773L14.2819 17.0951C14.5748 16.8022 15.0497 16.8022 15.3426 17.0951C15.6355 17.388 15.6355 17.8628 15.3426 18.1557L12.5301 20.9682C12.2372 21.2611 11.7623 21.2611 11.4694 20.9682L8.65694 18.1557C8.36405 17.8628 8.36405 17.388 8.65694 17.0951Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.45827 3.04931C8.5967 2.73005 9.80148 2.73367 10.938 3.05977C12.0745 3.38588 13.0979 4.02161 13.8938 4.89593C14.4656 5.52403 14.9038 6.25747 15.1862 7.05157C15.5077 6.92618 15.844 6.83856 16.1882 6.79132C16.8731 6.69734 17.5705 6.76583 18.224 6.99126C18.8775 7.21668 19.4689 7.59271 19.9502 8.08895C20.4315 8.58519 20.7892 9.18771 20.9946 9.84781C21.1999 10.5079 21.2471 11.2071 21.1322 11.8888C21.0174 12.5705 20.7437 13.2156 20.3334 13.7719C19.9231 14.3283 19.3876 14.7803 18.7703 15.0915C18.1638 15.3971 17.5999 15.5629 16.781 15.5629H15.3748C14.9606 15.5629 14.6248 15.2271 14.6248 14.8129C14.6248 14.3987 14.9606 14.0629 15.3748 14.0629H16.781C17.3431 14.0629 17.6772 13.9626 18.0952 13.752C18.5024 13.5467 18.8556 13.2486 19.1262 12.8816C19.3968 12.5147 19.5773 12.0892 19.6531 11.6395C19.7288 11.1899 19.6977 10.7288 19.5623 10.2934C19.4269 9.85799 19.1909 9.46058 18.8734 9.13328C18.556 8.80597 18.1659 8.55795 17.7349 8.40927C17.3039 8.26059 16.8439 8.21541 16.3921 8.2774C15.9404 8.33938 15.5096 8.50679 15.1345 8.76609C14.9256 8.91054 14.6577 8.93941 14.4228 8.84281C14.1879 8.74621 14.0178 8.53726 13.9709 8.28761C13.804 7.39899 13.3933 6.5743 12.7846 5.90571C12.1759 5.23712 11.3933 4.75096 10.5243 4.50159C9.65518 4.25222 8.73387 4.24945 7.86331 4.49359C6.99274 4.73774 6.20723 5.21918 5.59456 5.8841C4.98188 6.54903 4.5662 7.37123 4.39396 8.25883C4.22172 9.14642 4.29972 10.0644 4.61923 10.9102C4.93874 11.7561 5.48718 12.4963 6.20324 13.0484C6.91931 13.6004 7.77479 13.9424 8.67406 14.0362C9.08604 14.0792 9.38519 14.448 9.34223 14.86C9.29927 15.2719 8.93046 15.5711 8.51848 15.5281C7.34251 15.4055 6.22381 14.9582 5.28741 14.2363C4.35102 13.5145 3.63383 12.5464 3.21601 11.4403C2.79819 10.3342 2.6962 9.13378 2.92143 7.97308C3.14666 6.81238 3.69025 5.73719 4.49144 4.86767C5.29262 3.99816 6.31984 3.36858 7.45827 3.04931Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
